import { Injectable } from '@angular/core';
import { IMyAgent } from '../../../../interfaces/i-agents';

@Injectable({
  providedIn: 'root'
})
export class MyAgentsService {
  myAgents: IMyAgent[] = [];

  constructor() { }
}
